export default "__VITE_ASSET__DXPR$C9E__"